import { ISubmissionConditions } from "@models/SubmissionConditions.model";
import { Draft } from "./Draft.util";
import { getCalculateProgressParams } from "./getCalculateProgressParams";

export const getConditionsAcceptedProgressParamsUtil = (
  draft: Draft<ISubmissionConditions>,
  ignoreConditionsOfParticipationAccepted = false
) => {
  const requiredFieldsValues = [
    draft.conditionsAccepted?.includes("privaryPolicyAccepted") ? 1 : undefined,
  ];
  if (!ignoreConditionsOfParticipationAccepted)
    requiredFieldsValues.push(
      draft.conditionsAccepted?.includes("conditionsOfParticipationAccepted")
        ? 1
        : undefined
    );

  return getCalculateProgressParams(requiredFieldsValues);
};
